
var fncUpdateFooterPosition = function () {

//    $('#wrapper').css('height', (old_height - 100) + 'px');

    $('#sidebar-wrapper').css('height', 'auto');
    if ($(window).width() > 991) {
        var height = $('#page-wrapper').height() + 0; // var height = $('#page-wrapper').height() + 587; //($(document).height() + 250 - 500);
        var sidebar = $('#sidebar-wrapper').height() + 569;
    }
    else {
        var height = $('#page-wrapper').height() + 0; //($(document).height() + 250 - 500);
        var sidebar = $('#sidebar-wrapper').height() + 0;

    }
    var wrapper = $('#wrapper').height();
    if (sidebar > height) {
        height = sidebar;
    }

    old_height = height + 50;
    $('#wrapper').css('minHeight', old_height + 'px');
    $('#sidebar-wrapper').css('height', old_height + 'px');
    $('#sidebar-wrapper2').css('height', old_height + 'px');
}


function updateFooterPosition() {
    fncUpdateFooterPosition();
}